import {UploadedFile} from "../models/interfaces/uploaded-file.interface";
import {FileMetadataDto} from "../../core/models/interfaces/file-metadata-dto.interface";

export function convertUploadedFileToFileMetadataDto(uploadedFile: UploadedFile): FileMetadataDto {
    return {
        id: uploadedFile.id,
        name: uploadedFile.name,
        url: uploadedFile.url,
        sizeInBytes: uploadedFile.sizeInBytes.toString(),
        extension: uploadedFile.extension
    };
}
